import { Printers } from "../resbutler-utils/types/Printers";

const storageKey = (restaurantId: string) => `oms-filter-printer-ids-${restaurantId}`;

/** restaurant the loaded printers belong to (printers are fetched per restaurant) */
export const getPrintersRestaurantId = (printers: Printers): string | undefined => Object.values(printers ?? {})[0]?.restaurantId;

/** saved printer selection for the restaurant, limited to printers that still exist; null if nothing saved */
export const loadFilterPrinterIds = (printers: Printers): string[] | null => {
  const restaurantId = getPrintersRestaurantId(printers);
  if (!restaurantId) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey(restaurantId)) ?? "null");
    if (!Array.isArray(saved)) return null;
    return saved.filter((id) => !!printers[id]);
  } catch {
    return null;
  }
};

export const saveFilterPrinterIds = (printers: Printers, filterPrinterIds: string[]) => {
  const restaurantId = getPrintersRestaurantId(printers);
  if (!restaurantId) return;
  try {
    localStorage.setItem(storageKey(restaurantId), JSON.stringify(filterPrinterIds ?? []));
  } catch {
    // ignore storage errors
  }
};
